import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'OrderBasketCourierCard',
  components: {},
  props: {},
  data() {
    return {};
  },
  mounted() {},
  watch: {},
  computed: {
    ...mapGetters({
      courierProduct: 'order/courierProduct'
    }),
    priceUah() {
      return this.courierProduct.productPrices.data.find((item) => item.priceType === 'noid_uah')?.basePrice;
    }
  },
  methods: {
    ...mapMutations({})
  },

  beforeDestroy() {}
};
